import React, { useState } from 'react';

const API_BASE_URL = 'http://localhost:3000';

const LoginPage = ({ onNavigate }) => { 
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: loginId,
          senha: password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        const { token, user } = data;
        
        localStorage.setItem('authToken', token);
        localStorage.setItem('userName', user.nome);
        localStorage.setItem('userType', user.role);
        
        // Salvar ID com chave correta baseado no tipo
        if (user.role === 'RESTAURANTE') {
          localStorage.setItem('restauranteId', user.id);
        } else if (user.role === 'AGRICULTOR') {
          localStorage.setItem('agricultorId', user.id);
        }
        
        onNavigate('Perfil', user.nome, user.id, user.role);
      } else {
        setError(data.error || 'Credenciais inválidas. Verifique email e senha.');
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      setError('Erro de conexão com o servidor. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="form-container-split">
      <div className="split-left">
        <div className="split-left-icon">🌱</div>
        <h2>Conecte-se à agricultura local</h2>
        <p>
          Acesse sua conta e gerencie seus insumos, encontre fornecedores próximos 
          e receba recomendações personalizadas com inteligência artificial.
        </p>
      </div>
      
      <div className="split-right">
        <div style={{maxWidth: '420px', width: '100%'}}>
          <div className="form-brand">
            <div className="form-brand-icon">*</div>
          </div>
          
          <h2 className="page-title">
            Bem-vindo de volta
          </h2>
          <p className="page-subtitle">
            Entre na sua conta para continuar
          </p>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="loginId">Seu email</label>
              <input
                type="email"
                id="loginId"
                placeholder="exemplo@email.com"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Senha</label>
              <div className="input-with-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="input-icon-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>
            
            <button type="submit" className="form-button" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar na plataforma'}
            </button>
          </form>
          
          <div className="link-cadastro">
            Não tem uma conta? <span onClick={() => !loading && onNavigate('Cadastro', '')}>Cadastre-se</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;